import React, { useEffect, useMemo, useRef, useState } from 'react'
import Layout from '../../common/Layout'
import ReactSelect from 'react-select'
import AsyncSelect from 'react-select/async'
// import ReactSelect from '../ReactSelect/ReactSelect'
import { GetDataWithToken, PostDataWithToken } from '../../constants/ApiHelper'
import { useDispatch, useSelector } from 'react-redux'
import { dispatchMmvData } from '../../store/actions/userActions'
import ReactPaginate from 'react-paginate'
import { toast } from 'react-toastify'
import Loader from '../../common/Loader'
import { useForm } from 'react-hook-form'
import { debounce } from 'lodash'

const Mmv = () => {
  const dispatch = useDispatch()
  const apiUrl = {
    IF: 'https://uatmasterapi.flaskitsolutions.com',
    // IF :'https://test.insurefast.in/api/v1/',
    EC: 'https://api.expertcover.in/api/v3/'
  }
  // const apiUrl = 'https://test.insurefast.in/api/v1/'
  const mmvData = useSelector(state => state?.root?.mmvData)
  const userDetails = useSelector(state => state?.root?.userDetails)
  console.log('userDetails', userDetails)

  const [resetAction, setResetAction] = useState(false)

  const [action, setAction] = useState(false)
  const [model, setModel] = useState(false)
  const [insurerData, setInsurerData] = useState([])
  console.log("insurerData",insurerData);
  
  const [vehicleType, setVehicleType] = useState('')
  const [insurer, setInsurer] = useState('')
  const [partnerMmvData, setPartnerMmvData] = useState([])
console.log("partnerMmvData",partnerMmvData);

  const [insurerMmvData, setInsurerMmvData] = useState([])
  const [makeData, setMakeData] = useState([])
  const [modelData, setModelData] = useState([])
  const [varientData, setVarientData] = useState([])
  const [fuelType, setFuelType] = useState([])
  const [selectedFuelType, setSelectedFuelType] = useState('')
  const [makeId, setMakeId] = useState('')
  const [modelId, setModelId] = useState('')
  const [filter, setFilter] = useState(false)
  const [loading, setLoading] = useState(false)
  const [selectedValue, setSelectedValue] = useState('')
  const [selectedMake, setSelectedMake] = useState(null)
  const [selectedModal, setSelectedModal] = useState(null)
  const [selectedVarient, setSelectedVarient] = useState(null)
  const [errors, setErrors] = useState({})
  const [selectedStatus, setSelectedStatus] = useState('')
  const [currentItemsData, setCurrentItemsData] = useState(false)
  const [totalPage, setTotalPage] = useState("");
  const [pageLimit, setPageLimit] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  

  // Pagination Start
  const [pageCount, setPageCount] = useState()
  console.log("pageCount---",pageCount);
  
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [itemOffset, setItemOffset] = useState(0)

  const handlePageClick = (e) => {
    setCurrentPage(e.selected + 1);
  };

  const endOffset = itemOffset + itemsPerPage
  const currentItems =
    partnerMmvData && partnerMmvData.slice(itemOffset, endOffset)
  const handleChangeItemPerPage = (value) => {
    setPageLimit(value);
    setItemOffset(0);
  };

    useEffect(() => {
      if (pageLimit && currentPage) {
       getPartnerMMV()
      }
    }, [pageLimit, currentPage]);
  useEffect(() => {
    currentItems.map(item => {
      const value = insurerMmvData.find(data => item?.bajaj === data?.value)
    })
  }, [currentItems])

  // Pagination End

  // useEffect(() => {
  //   if (userDetails?.productOwner === 'EC') {
  //     dispatchMmvData('apiUrl', apiUrl?.EC)
  //     handleSelectProduct(apiUrl?.EC)
  //   } else if (userDetails?.productOwner === 'IF') {
  //     dispatchMmvData('apiUrl', apiUrl?.IF)
  //     handleSelectProduct(apiUrl?.IF)
  //   }
  // }, [])

  // Select Product
  // const handleSelectProduct = val => {
  //   setLoading(true)
  //   // if (val === 'INSFST') {
  //   //   // dispatchMmvData('apiUrl', URL_INSFST)
  //   //   dispatchMmvData('partnerName', val)
  //   // } else if (val === 'RETRO') {
  //   //   dispatchMmvData('apiUrl', URL_RETRO)
  //   //   dispatchMmvData('partnerName', val)
  //   // } else if (val === 'EXPERT') {
  //   //   dispatchMmvData('apiUrl', URL_EXPERT)
  //   //   dispatchMmvData('partnerName', val)
  //   // } else {
  //   //   dispatchMmvData('apiUrl', '')
  //   // }
  //   GetDataWithToken(val, 'admin/getAllInsData').then(res => {
  //     console.log('res----', res)
  //     setLoading(false)
  //     if (res?.status === 'success') {
  //       setInsurerData(res?.data)
  //     } else {
  //       console.log('Insurer Data', res?.status)
  //     }
  //   })
  // }

const handleSelectProduct = val => {
  setLoading(true);
  
  // Add query parameters correctly, removing any extra commas
  let data = new URLSearchParams({
    isMmvPanel: true,
    vehicleType: vehicleType, // Ensure this is passed without any extra commas or spaces
  }).toString();

  GetDataWithToken(`/insurers/getAllInsurer?${data}`).then(res => {
    setLoading(false);
    if (res?.success) {
      setInsurerData(res?.data);
    } else {
      console.log('Insurer Data', res?.status);
    }
  });
}

  // const handleSelectInsurer = (val, insurerData) => {
  //   setInsurer(val)
  //   dispatchMmvData('insurerName', val)
  //   const a = insurerData.filter(x => x.insurerName === val)
  //   const id = a[0].insurerId
  //   dispatchMmvData('insurerId', id)
  // }
  const handleSelectInsurer = (val, insurerData) => {
    debugger
    // setVehicleType('')
    // dispatchMmvData('vehicleType', '')
    setSelectedMake(null)
    setSelectedModal(null)
    setSelectedVarient(null)
    setFuelType(null)
    dispatchMmvData('fuelType', '')
    setSelectedFuelType('')
    setVariantIdInput(null)
    dispatchMmvData('makeId', '')
    dispatchMmvData('modelId', '')
    dispatchMmvData('varientId', '')
    dispatchMmvData('action', '')
    setSelectedStatus('')
    setInsurer(val)
    setCurrentItemsData(false)
    dispatchMmvData('insurerId', val)
    dispatchMmvData('insurerMmvId', '')
    const selectedInsurer = insurerData.find(x => x.insurerId == val)
    const insurerName = selectedInsurer ? selectedInsurer.insurerName : ''
    const mappingName = selectedInsurer ? selectedInsurer.mappingName : ''
    dispatchMmvData('insurerName', insurerName)
    dispatchMmvData('mappingName', mappingName)
  }
//   useEffect(() => {
//   if (vehicleType && mmvData?.apiUrl) {
//     handleSelectProduct(mmvData?.apiUrl);
//   }
// }, [vehicleType, mmvData?.apiUrl]);

const handleSelectVehicleType = val => {
  setInsurer('');
  dispatchMmvData('insurerId', '');
  dispatchMmvData('insurerName', '');
  dispatchMmvData('mappingName', '');
  dispatchMmvData('make', '')
  dispatchMmvData('model', '')
  dispatchMmvData('variant', '')
  setSelectedMake(null);
  setSelectedModal(null);
  setSelectedVarient(null);
  setFuelType(null);
  dispatchMmvData('fuelType', '');
  setSelectedFuelType('');
  setVariantIdInput(null);
  dispatchMmvData('makeId', '');
  dispatchMmvData('modelId', '');
  dispatchMmvData('varientId', '');
  dispatchMmvData('action', '');
  setCurrentItemsData(false);
  
  // Set the vehicle type without extra characters
  const vehicleTypeClean = val?.trim();  // This ensures no trailing commas or spaces
  setVehicleType(vehicleTypeClean);
  dispatchMmvData('vehicleType', vehicleTypeClean);

  if (userDetails?.productOwner === 'EC') {
    dispatchMmvData('apiUrl', apiUrl?.EC);
  } else if (userDetails?.productOwner === 'IF') {
    dispatchMmvData('apiUrl', apiUrl?.IF);
  }
};
useEffect(() => {
  if (vehicleType && mmvData?.apiUrl) {
    handleSelectProduct(mmvData?.apiUrl);
  }
}, [vehicleType, mmvData?.apiUrl]);


  // Get MMV Data of Insurer and Partner
  const getInsurerMmv = () => {
    setLoading(true)
    let insurerObj = {
      insurerId: mmvData?.insurerId,
      insurerName: mmvData?.insurerName,
      vehicleType: mmvData?.vehicleType,

      mmvFullName: ''
    }
    PostDataWithToken(
      '/mmv/getInsurerMmvData',
      insurerObj
    ).then(res => {
      let data = res?.data
      let i = 0
      let arr = []
      while (i < data?.length) {
        let item = data[i]
        arr.push({
          label: item?.mmvFullName,
          value: item?.id
        })
        i++
      }
      setInsurerMmvData(arr)
      setLoading(false)
    })
  }
  const resetPartnerMmv = () => {
    setLoading(true)
    setSelectedMake(null)
    setSelectedModal(null)
    setSelectedVarient(null)
    setFuelType(null)
    setSelectedStatus('')
    setSelectedFuelType('')
    setVariantIdInput(null)
    dispatchMmvData('makeId', '')
    dispatchMmvData('modelId', '')
    dispatchMmvData('fuelType', '')
    dispatchMmvData('varientId', '')
    dispatchMmvData('action', '')
    dispatchMmvData('insurerMmvData', '')
    getPartnerMMV('', '', '', '')
  }
  // Get Partner MMV
  const getPartnerMMV = (val1, val2, val3, val4) => {
    setLoading(true)
    let modelVal = model ? val2 : ''
    let partnerObj = {
      makeId: val1 === mmvData?.makeId ? mmvData?.makeId : val1,
      mmvFullName: '',
      vehicleType: mmvData?.vehicleType,
      modelId: modelVal === mmvData?.modelId ? mmvData?.modelId : modelVal,
      variantId: val3 !== "" ? val3 : val3,
            search: variantIdInput,
      fuelType: selectedFuelType || '',
      insurerId: mmvData?.insurerId || '',
      action: val4 !== '' ? val4 : '',
      limit: pageLimit,
      currentPage: currentPage,
    
    }
    if (!variantIdInput) {
      partnerObj = {
        ...partnerObj
      }
    }

    PostDataWithToken('/mmv/getMmvData', partnerObj).then(
      res => {
        setPartnerMmvData(res?.data)
        setPageCount(res?.totalPages)
        const fuelTypes = res?.data.map(item => item?.fuelType)
        const uniqueFuelTypes = [...new Set(fuelTypes)]
        partnerObj.fuelType = uniqueFuelTypes.join(', ')
        setFuelType(partnerObj.fuelType)
        setLoading(false)
      }
    )
    setModel(true)
  }
  // Get Make Data
  const getMakeData = val => {
    setLoading(true)
    let makeObj = {
      vehicleType: mmvData?.vehicleType
    }
    PostDataWithToken( '/mmv/getAllMakeData', makeObj).then(
      res => {
        let data = res?.data
        let i = 0
        let arr = []
        while (i < data?.length) {
          let item = data[i]
          arr.push({
            label: item?.make,
            value: item?.makeId
          })
          i++
        }
        setMakeData(arr)
        setLoading(false)
      }
    )
  }
  // const handleSubmit = () => {
  //   setLoading(true)
  //   getInsurerMmv()
  //   getPartnerMMV()
  //   getMakeData()
  // }
  const validateForm = () => {
    const newErrors = {}
    if (!insurer) newErrors.insurer = 'Please select an insurer.'
    if (!vehicleType) newErrors.vehicleType = 'Please select a vehicle type.'
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = () => {
    if (!validateForm()) return
    setCurrentItemsData(true)
    setLoading(true)
    getInsurerMmv()
    getPartnerMMV()
    getMakeData()
  }

  // const handleSelectInsurerMmvId = (selectedOption, itemId) => {
  //   dispatchMmvData('insurerMmvId', selectedOption?.value)
  //   setSelectedValue(prevSelected => ({
  //     ...prevSelected,
  //     [itemId]: selectedOption
  //   }))
  // }

  const handleSelectInsurerMmvId = useMemo(
    () =>
      debounce((selectedOption, itemId) => {
        dispatchMmvData('insurerMmvId', selectedOption?.value)
        setSelectedValue(prevSelected => ({
          ...prevSelected,
          [itemId]: selectedOption
        }))
      }, 300), // 300ms debounce
    [] // Dependencies
  )
  // const handleSelectInsurerMmvId = (item) => {
  //   console.log("handleSelectInsurerMmvId", item);
  //   dispatchMmvData("insurerMmvId", item?.value);
  // };

  // useEffect(() => {
  //   // console.log('selectedOption', selectedValue)
  // }, [selectedValue])

  const resetData = () => {
    dispatchMmvData('fuelType', '')

    setSelectedVarient(null)
    dispatchMmvData('varientId', '')
    dispatchMmvData('modelId', '')
    setSelectedFuelType(null)
    setSelectedModal(null)
    setFuelType(null)
  }
  const handleSelectMake = (val, selectedOption) => {
    resetData()
    setMakeId(val)
    setSelectedMake(selectedOption)
    dispatchMmvData('makeId', val)
    resetAction === false
      ? getPartnerMMV(val, '', '', '')
      : getPartnerMMV(val, '', '', mmvData?.action)
    setResetAction(true)
  }

  const handleSelectModel = (val, selectedOption) => {
    setModelId(val)
    setFuelType(null)
    setSelectedVarient(null)
    setSelectedModal(selectedOption)
    dispatchMmvData('modelId', val)
    let actionVal = action ? mmvData?.action : ''
    getPartnerMMV(mmvData?.makeId, val, '', actionVal)
  }

  const handleSelectVarient = (val, selectedOption) => {
    setSelectedVarient(selectedOption)
    dispatchMmvData('varientId', val)
    getPartnerMMV(mmvData?.makeId, mmvData?.modelId, val, '')
  }

  const handleSelectMapData = val => {
    dispatchMmvData('action', val)
    setAction(true)

    setSelectedStatus(val) // Update state with the selected value
    getPartnerMMV(mmvData.makeId, mmvData.modelId, mmvData.varientId, val)
  }
  // Get Modal Data
  const getModelData = val => {
    setModelData([])
    setVarientData([])

    dispatchMmvData('makeId', val)
    setLoading(true)
    let makeObj = {
      vehicleType: mmvData?.vehicleType,
      makeId: val
    }
    PostDataWithToken( '/mmv/getAllModelData', makeObj).then(
      res => {
        let data = res?.data
        let i = 0
        let arr = []
        while (i < data?.length) {
          let item = data[i]
          arr.push({
            label: item?.model,
            value: item?.modelId
          })
          i++
        }
        setModelData(arr)
        setLoading(false)
      }
    )
  }
  //Get Variant Data
  const getVariantData = val => {
    setLoading(true)
    dispatchMmvData('modelId', val)
    let makeObj = {
      vehicleType: mmvData?.vehicleType,
      makeId: makeId ? makeId : mmvData?.makeId,
      modelId: val
    }
    PostDataWithToken('/mmv/getAllVariantData', makeObj).then(
      res => {
        let data = res?.data
        let i = 0
        let arr = []
        while (i < data?.length) {
          let item = data[i]
          arr.push({
            label: item?.variant,
            value: item?.variantId
          })
          i++
        }
        setVarientData(arr)
        setLoading(false)
      }
    )
  }
  // mapping data
  const handleMapping = (item, matchingMmv) => {    
    setLoading(true)
    let mapObj = {
      vehicleType: mmvData?.vehicleType,
      insurerMmvId: mmvData?.insurerMmvId
        ? mmvData?.insurerMmvId
        : matchingMmv?.value,
      insurerId: mmvData?.insurerId,
      insFastMmvId: item,
      action: 'mapped'
    }
    PostDataWithToken( '/mmv/mapMmvData', mapObj).then(res => {
      setLoading(false)
      if (res?.success) {
        toast.success(res.message)
      } else {
        toast.error('Something went wrong')
      }
    })
  }
  //unmap data
  const handleUnMapping = item => {
    setLoading(true)
    let mapObj = {
      vehicleType: mmvData?.vehicleType,
      insurerMmvId: '',
      insurerId: mmvData?.insurerId,
      insFastMmvId: item,
      action: 'unmapped'
    }
    PostDataWithToken( '/mmv/mapMmvData', mapObj).then(res => {
      setLoading(false)
      if (res?.success) {
        toast.success(res.message)
      } else {
        toast.error(res.message)
      }
    })
  }

  const handleFuelType = val => {
    dispatchMmvData('fuelType', val)
    setSelectedFuelType(val)
    // getPartnerMMV(mmvData?.makeId, mmvData?.modelId, val,'')
    
  }
  const handleFilter = () => {
    setFilter(!filter)
  }

  const [variantIdInput, setVariantIdInput] = useState('')
  const handleVariantIdChange = e => {
    setVariantIdInput(e.target.value)
  }
  const [searchType, setSearchType] = useState('search')
    const handleSearch = () => {
        if (searchType === 'search') {
            getPartnerMMV('', '', '', variantIdInput)

        }

    }

  // text copy

  const handleCopyText = value => {
    const textToCopy = value

    // Use the Clipboard API if available
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          toast.success('Copied to clipboard!')
          console.log(textToCopy, 'click text')
        })
        .catch(err => {
          console.error('Failed to copy text: ', err)
          toast.error('Failed to copy text!')
        })
    } else {
      const textarea = document.createElement('textarea')
      textarea.value = textToCopy
      document.body.appendChild(textarea)
      textarea.select()

      try {
        document.execCommand('copy')
        toast.success('Copied to clipboard!')
      } catch (err) {
        console.error('Failed to copy text: ', err)
        toast.error('Failed to copy text!')
      } finally {
        document.body.removeChild(textarea)
      }
    }
  }
  return (
    <Layout>
      <div className='container-fluid py-4 dash_main'>
        <div className='row'>
          {/* <div className='col-12'> */}
          <div className='card mb-4'>
            <div className='card-body pt-0 pb-2'>
              <div className='row mt-2'>
                {/* <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                    <label>Product</label>
                    <div className='mb-3'>
                      <select
                        className='form-control'
                        onChange={e => handleSelectProduct(e?.target?.value)}
                        // defaultValue={mmvData?.partnerName || ""}
                        // value={mmvData.partnerName}
                      >
                        <option key='' value=''>
                          Select Product
                        </option>
                        <option
                          key='INSFST'
                          selected={
                            mmvData?.partnerName === 'INSFST' ? true : false
                          }
                          value='INSFST'
                        >
                          Insurefast
                        </option>
                      </select>
                    </div>
                  </div> */}

                {/* <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                    <label>Insurer</label>
                    <div className='mb-3'>
                      <select
                        className='form-control'
                        onChange={e =>
                          handleSelectInsurer(e.target.value, insurerData)
                        }
                        value={insurerData.insurerName}
                      >
                        <option key='' value=''>
                          Select Insurance
                        </option>
                        {insurerData?.map((item, index) => {
                          return (
                            <option
                              key={index}
                              selected={
                                insurerData
                                  ? insurerData?.find(insurer => {
                                      if (
                                        insurer?.insurerId &&
                                        insurerData?.insurerName
                                      ) {
                                        return (
                                          parseInt(insurerData?.insurerName) ===
                                          insurer?.insurerId
                                        )
                                      }
                                      return false 
                                    })?.mappingName
                                  : false
                              }
                              value={item?.insurerName}
                            >
                              {item?.mappingName}
                            </option>
                          )
                        })}
                      </select>
                    </div>
                  </div>

                  <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                    <label>Vechicle Type</label>
                    <div className='mb-3'>
                      <select
                        className='form-control'
                        onChange={e => handleSelectVehicleType(e.target.value)}
                        value={mmvData.vehicleType}
                        name='vehicleType'
                        id='vehicleType'
                      >
                        <option key='' value=''>
                          Select Vechicle
                        </option>
                        <option
                          key='2w'
                          value='2w'
                          selected={
                            mmvData?.vehicleType === '2w' ? true : false
                          }
                        >
                          Two Wheeler
                        </option>
                        <option
                          key='4w'
                          value='4w'
                          selected={
                            mmvData?.vehicleType === '4w' ? true : false
                          }
                        >
                          Private Car
                        </option>
                        <option
                          key='pcv'
                          value='pcv'
                          selected={
                            mmvData?.vehicleType === 'pcv' ? true : false
                          }
                        >
                          Passanger Carrying Vehicle
                        </option>
                        <option
                          key='gcv'
                          value='gcv'
                          selected={
                            mmvData?.vehicleType === 'gcv' ? true : false
                          }
                        >
                          Goods Carrying Vehicle
                        </option>
                        <option
                          key='misc'
                          value='misc'
                          selected={
                            mmvData?.vehicleType === 'misc' ? true : false
                          }
                        >
                          Miscelleneous Vehicle
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                    <label></label>
                    <div className='mb-3 d-flex justify-content-end gap-3'>
                      <button
                        type='button'
                        class='btn btn-sec'
                        onClick={() => handleSubmit()}
                        disabled={loading}
                      >
                        
                        submit
                      </button>
                    </div>
                  </div> */}
                  <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                  <label>Vehicle Type</label>
                  <div className='mb-3'>
                    <select
                      className='form-control'
                      onChange={e => handleSelectVehicleType(e.target.value)}
                      value={vehicleType}
                      name='vehicleType'
                      id='vehicleType'
                    >
                      <option value=''>Select Vehicle</option>
                      <option value='2w'>Two Wheeler</option>
                      <option value='4w'>Private Car</option>
                      <option value='pcv'>Passenger Carrying Vehicle</option>
                      <option value='gcv'>Goods Carrying Vehicle</option>
                      <option value='misc'>Miscellaneous Vehicle</option>
                    </select>
                    {errors.vehicleType && (
                      <div className='text-danger'>{errors.vehicleType}</div>
                    )}
                  </div>
                </div>
                <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                  <label>Insurer</label>
                  <div className='mb-3'>
                    <select
                      className='form-control'
                      onChange={e =>
                        handleSelectInsurer(e.target.value, insurerData)
                      }
                      value={insurer}
                    >
                      <option value=''>Select Insurance</option>
                      {insurerData?.map((item, index) => (
                        <option key={index} value={item?.insurerId}>
                          {item?.mappingName}
                        </option>
                      ))}
                    </select>
                    {errors.insurer && (
                      <div className='text-danger'>{errors.insurer}</div>
                    )}
                  </div>
                </div>

                

                <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                  <label></label>
                  <div className='mb-3 d-flex justify-content-end gap-3'>
                    <button
                      type='button'
                      className='btn btn-sec'
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? 'Loading...' : 'Submit'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {currentItemsData ? (
            <>
              <div className='card mb-4 pt-2 pb-2'>
                <div onClick={handleFilter}>
                  <button
                    className={filter ? 'filter-btn active' : 'filter-btn'}
                  >
                    {' '}
                    Show Filter
                  </button>
                </div>
                {filter && (
                  <div className='card-body pt-0 pb-2'>
                    <div className='row'>
                      <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                        <label>Make</label>
                        <ReactSelect
                          options={makeData}
                          name='Make'
                          placeholder='Select make'
                          value={selectedMake}
                          onChange={e => {
                            handleSelectMake(e?.value)
                            getModelData(e?.value)
                          }}
                        />
                      </div>
                      <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                        <label>Model</label>
                        <ReactSelect
                          options={modelData}
                          name='Model'
                          placeholder='Select model'
                          value={selectedModal}
                          onChange={e => {
                            handleSelectModel(e?.value)
                            getVariantData(e?.value)
                          }}
                        />
                      </div>
                      <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                        <label>Fuel Type</label>
                        <div className='mb-3'>
                          <div className='mb-3'>
                            <select
                              className='form-control'
                              id='fuelSelect'
                              name='fuelSelect'
                              onChange={e => handleFuelType(e.target.value)}
                            >
                              <option value=''>Select fuel</option>
                              {typeof fuelType === 'string' &&
                                fuelType.split(', ').map((type, index) => (
                                  <option key={index} value={type}>
                                    {type}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                        <label>Varient</label>
                        <ReactSelect
                          options={varientData}
                          name='Model'
                          placeholder='Select Varient'
                          value={selectedVarient}
                          onChange={e => handleSelectVarient(e?.value)}
                        />
                      </div>
                      <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                        <label>Status</label>
                        <div className='mb-3'>
                          <select
                            className='form-control'
                            value={selectedStatus} // Bind the selected value to state
                            // onChange={handleSelectMapData}
                            onChange={e => handleSelectMapData(e.target.value)} // Call the handler on selection
                          >
                            <option key='' value=''>
                              All
                            </option>
                            <option key='mapped' value='mapped'>
                              Mapped
                            </option>
                            <option key='unmapped' value='unmapped'>
                              Unmapped
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className='col-xl-9 col-lg-3 col-md-6 col-12 mt-4 d-flex justify-content-end align-items-center'>
                        <button
                          type='button'
                          className='btn btn-danger'
                          onClick={() => resetPartnerMmv()}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {/* </div> */}
              {loading ? (
                <>
                  <div className='loading'>
                    <div className='spinner'></div>
                    <p>Loading...</p>
                  </div>
                </>
              ) : (
                <>
                  {currentItems?.length > 0 ? (
                    <div className='col-12'>
                      <div className='card mb-4'>
                        <div className='card-body pt-0 pb-2'>
                          <div className='row'>
                            <div className='col-xl-3 col-lg-3 col-md-6 col-12 d-flex align-items-center gao-1'>
                              <div>
                                <label>Variant ID</label>
                                <div className='mb-3'>
                                  <input
                                    type='search'
                                    placeholder='Variant ID'
                                    className='form-control'
                                    value={variantIdInput}
                                    onChange={handleVariantIdChange}
                                  />
                                </div>
                              </div>
                              <div
                                className='mt-3 secrch-btn'
                                onClick={() => handleSearch()}
                              >
                                <button>search</button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='card-body pt-0 pb-2'>
                          <div className='table-responsive p-0'>
                            <table className='table align-items-center mb-0'>
                              <thead>
                                <tr>
                                  <th className='text-uppercase text-xxs font-weight-bolder text-dark'>
                                    Variant Id
                                  </th>
                                  <th className='text-uppercase text-xxs font-weight-bolder text-dark'>
                                    Product Mmv
                                  </th>
                                  <th className='text-uppercase text-xxs font-weight-bolder text-dark'>
                                    Insurer
                                  </th>
                                  <th
                                    className='text-uppercase  text-xxs font-weight-bolder fs-4'
                                    style={{ color: '#000' }}
                                  >
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {currentItems.map((item, index) => {
                                  const insurerMmvId =
                                    item[mmvData?.mappingName]
                                  const insurerName = mmvData?.mappingName
                                  const matchingMmv = insurerMmvData.find(
                                    data => data.value === insurerMmvId
                                  )
                                  console.log(insurerName, 'insurerName')
                                  return (
                                    <tr key={index}>
                                      <td
                                        className='select_variant'
                                        onClick={() =>
                                          handleCopyText(item?.variantId)
                                        }
                                        style={{ cursor: 'pointer' }}
                                      >
                                        {item?.variantId}
                                      </td>
                                      <td className='select_partner'>
                                        {item?.mmvFullName}
                                      </td>
                                      <td style={{ width: '45%' }}>
                                        <div className='mmv_select'>
                                          <ReactSelect
                                            options={insurerMmvData}
                                            name='MMV'
                                            value={
                                              selectedValue[item.id] ||
                                              matchingMmv ||
                                              null
                                            }
                                            placeholder='Select MMV'
                                            onChange={selectedOption =>
                                              handleSelectInsurerMmvId(
                                                selectedOption,
                                                item.id
                                              )
                                            }
                                            className='select_ins'
                                            menuPortalTarget={document.body}
                                            // components={{ MenuList }}
                                            styles={{
                                              menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999
                                              })
                                            }}
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div className='d-flex gap-2'>
                                          <button
                                            type='button'
                                            className='btn btn-sec'
                                            onClick={() =>
                                              handleMapping(
                                                item?.id,
                                                matchingMmv
                                              )
                                            }
                                          >
                                            {/* {loading ? <Loader /> : 'Map'} */}
                                            map
                                          </button>
                                          <button
                                            type='button'
                                            className='btn suc-btn'
                                            onClick={() =>
                                              handleUnMapping(item?.id)
                                            }
                                          >
                                            {/* {loading ? <Loader /> : 'Unmap'} */}
                                            Unmap
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className='card mb-4 p-3'>
                        <div className='d-flex align-items-center justify-content-between flex-wrap'>
                          <div>
                            <p>
                              Showing 1 - {itemsPerPage} items of{' '}
                              {partnerMmvData?.length}
                            </p>
                          </div>
                          <div className='main-page-item'>
                            <div className='show-page'>
                              <select
                                className='form-control'
                                onClick={e =>
                                  handleChangeItemPerPage(e?.target?.value)
                                }
                              >
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={30}>30</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                              </select>
                            </div>
                            <div>
                            <ReactPaginate
  breakLabel="..."
  nextLabel="Next"
  previousLabel="Prev"
  onPageChange={handlePageClick}
  pageCount={pageCount}
  forcePage={currentPage - 1}
  pageRangeDisplayed={5}
  marginPagesDisplayed={2}
  containerClassName="pagination"
  pageClassName="page-item"
  pageLinkClassName="page-link"
  previousClassName="page-item"
  previousLinkClassName="page-link"
  nextClassName="page-item"
  nextLinkClassName="page-link"
  activeClassName="active"
/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p style={{ textAlign: 'center', fontSize: '1rem' }}>
                      {' '}
                      No Record Found
                    </p>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <p style={{ textAlign: 'center', fontSize: '1rem' }}>
                {' '}
                No Record Found
              </p>
            </>
          )}
        </div>
      </div>
    </Layout>
  )
}

export default Mmv
